<template>
  <div v-if="products && products.length" class="bg-blackly">
    <div
      class="lg:max-w-screen-xl md:border-t-0 whitespace-nowrap container relative overflow-x-auto overflow-y-hidden border-t border-gray-800"
    >
      <div class="flex flex-row items-center fluid-base leading-relaxed font-light text-white">
        <span class="fluid-xs leading-tightest text-br-green-light font-medium">{{
          $t('exercises.productsInRoutine')
        }}</span>
        <nuxt-link
          v-for="{ title, uri, icon } in products"
          :key="uri"
          tag="div"
          class="overflow-none hover:scale-105 flex flex-row items-center justify-center py-2 ml-8 mr-4 fluid-xs leading-tightest font-medium transition-transform duration-200 transform cursor-pointer"
          :to="{ path: $localeRootPath(uri) }"
        >
          <img v-if="icon[0]" :src="icon[0].url" :alt="icon[0].alt" class="block w-8 mx-2" />
          <div class="block">
            {{ title }}
          </div>
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    products: {
      type: Array,
      default: () => []
    }
  }
}
</script>
